"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.patientRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    getPatientOrderableProducts: {
        callMethod: 'GET',
        endpoint: '/patient/products/orderable',
    },
    getCumulusId: {
        callMethod: 'GET',
        endpoint: '/patient/cumulusId',
    },
    updateCumulusId: {
        callMethod: 'POST',
        endpoint: '/patient/cumulusId',
    },
    getSuccessfulLogins: {
        callMethod: 'GET',
        endpoint: '/patient/successul-logins',
    },
    getPatientInformation: {
        callMethod: 'GET',
        endpoint: '/patient/info',
    },
    getHealthQuestionnaire: {
        callMethod: 'GET',
        endpoint: '/patient/health-questionnaire',
    },
    updateHealthQuestionnaire: {
        callMethod: 'POST',
        endpoint: '/patient/health-questionnaire/update',
    },
    deactivateMediplus: {
        callMethod: 'POST',
        endpoint: '/patient/mediplus/deactivate',
    },
    getNextDailymedBox: {
        callMethod: 'GET',
        endpoint: '/patient/dailymed/box/next',
    },
    savePatientAddress: {
        callMethod: 'POST',
        endpoint: '/patient/address',
    },
    savePatientEmail: {
        callMethod: 'POST',
        endpoint: '/patient/email/save',
    },
    savePatientInsuranceData: {
        callMethod: 'POST',
        endpoint: '/patient/insurance/save',
    },
    savePatientPersonalData: {
        callMethod: 'POST',
        endpoint: '/patient/info/save',
    },
    savePatientContactData: {
        callMethod: 'POST',
        endpoint: '/patient/contact/save',
    },
    changePatientEmail: {
        callMethod: 'POST',
        endpoint: '/patient/email/change',
    },
    changePatientUsername: {
        callMethod: 'POST',
        endpoint: '/patient/username/change',
    },
    setGenericMedicamentSubstitution: {
        callMethod: 'POST',
        endpoint: '/patient/generic-medicament-substitution',
    },
    setPatientMedicationSubstitutionAllowed: {
        callMethod: 'POST',
        endpoint: '/patient/medication-substitution-allowed',
    },
    setMedicationSubstitution: {
        callMethod: 'POST',
        endpoint: '/patient/medication-substitution',
    },
    setPatientLanguage: {
        callMethod: 'POST',
        endpoint: '/patient/language',
    },
    savePatientTermsAndConditionsConsent: {
        callMethod: 'POST',
        endpoint: '/patient/terms-and-conditions',
    },
    getAllDoctorsForPatient: {
        callMethod: 'GET',
        endpoint: '/patient/doctors',
    },
    getPatientDataSource: {
        callMethod: 'GET',
        endpoint: '/patient/data-source',
    },
    saveCommunicationSettings: {
        callMethod: 'POST',
        endpoint: '/patient/communication-settings/save',
    },
    validateUsername: {
        callMethod: 'POST',
        endpoint: '/patient/validate-username',
    },
    setPatientAlreadyCustomer: {
        callMethod: 'POST',
        endpoint: '/patient/already-customer',
    },
    deactivatePatient: {
        callMethod: 'POST',
        endpoint: '/patient/deactivate',
    },
    deletePatientAddress: {
        callMethod: 'POST',
        endpoint: '/patient/address/delete',
    },
    changePassword: {
        callMethod: 'POST',
        endpoint: '/patient/password/change',
    },
    confirmEmail: {
        callMethod: 'GET',
        endpoint: '/patient/email/confirm',
    },
    lostPassword: {
        callMethod: 'POST',
        endpoint: '/patient/password/lost',
    },
    proposeUsernameWithToken: {
        callMethod: 'POST',
        endpoint: '/username/propose-with-token',
    },
    proposeUsername: {
        callMethod: 'POST',
        endpoint: '/username/propose',
    },
    startRegistration: {
        callMethod: 'POST',
        endpoint: '/registration/start',
    },
    registerPatient: {
        callMethod: 'POST',
        endpoint: '/patient/register',
    },
    createLeanRegistrationRequest: {
        callMethod: 'POST',
        endpoint: '/patient/register/lean/create',
    },
    registerPatientLean: {
        callMethod: 'POST',
        endpoint: '/patient/register/lean',
    },
    checkPatientExists: {
        callMethod: 'GET',
        endpoint: '/patient/exists',
    },
    getCustomerIdByToken: {
        callMethod: 'GET',
        endpoint: '/customer/get-id',
    },
    registerPatientByActivationToken: {
        callMethod: 'POST',
        endpoint: '/patient/register/by-activation-token',
    },
    getPatientEventData: {
        callMethod: 'GET',
        endpoint: '/patient/events',
    },
    updatePatientEventConfiguration: {
        callMethod: 'PUT',
        endpoint: '/patient/events/update',
    },
    getUnreadMessagesCount: {
        callMethod: 'GET',
        endpoint: '/patient/events/unread-message-count',
    },
    setMessageAsRead: {
        callMethod: 'POST',
        endpoint: '/patient/events/set-read',
    },
    setNewsletter: {
        callMethod: 'PUT',
        endpoint: '/communication/set-newsletter',
    },
    getCommunicationSettings: {
        callMethod: 'GET',
        endpoint: '/communication/settings',
    },
    updateCommunicationSettings: {
        callMethod: 'PUT',
        endpoint: '/communication/update-settings',
    },
    unsubscribeCampaign: {
        callMethod: 'PUT',
        endpoint: '/campaign/unsubscribe',
    },
    updatePassword: {
        callMethod: 'PUT',
        endpoint: '/user/password/update',
    },
    registrationDataValid: {
        callMethod: 'POST',
        endpoint: '/patient/register/valid',
    },
});
//# sourceMappingURL=patient.methods.js.map